import {Head, Link} from '@inertiajs/react'
import Layout from "../../components/layout";
import {ArrowLeftIcon,} from "@heroicons/react/24/outline";
import Album from '../../components/album.jsx';

export default function Authenticate({event}) {

    return (
        <Layout>
            <Head title={event.name + ' - Album'} />
            <div className="flex flex-col px-5 flex-grow h-full">
                <div className="sticky top-0 z-10 pt-5 backdrop-blur">

                    <div className="flex items-center">
                        {allowBack && <Link href={backUrl}>
                            <div
                                className="flex-row mr-5 items-center border-2 border-[#2F2F2F] bg-[rgba(41,41,41,0.70)] rounded-[20px] p-[7px]">
                                <ArrowLeftIcon className="w-[25px] h-[25px] text-white" />
                            </div>
                        </Link>}
                        <div>
                            <h1 className="text-white leading-tight text-xl md:text-3xl font-bold">{event.name}'s
                                Album</h1>
                            <span className="text-xs text-white leading-tight">{event.organizer.name}</span>
                        </div>
                    </div>

                    <div className="mt-1">
                        <label htmlFor="effect" className="text-white">Filter effect</label>
                        <select name="effect"
                                className="w-full mt-1 rounded-full border-2 border-[#2F2F2F] bg-[rgba(41,41,41,0.70)] text-white"
                                onChange={onEffectChange} value={effect}>
                            {effects.map(e => <option key={e.value} value={e.value}>{e.label}</option>)}
                        </select>
                    </div>
                    <div className="flex text-center">
                        {uploadUrl &&
                            <a className="flex-wrap w-full shadow transition duration-300 transform px-6 py-3 font-medium text-white mt-[10px] rounded-[10px] focus:outline-none hover:shadow-md bg-primary-500 hover:bg-primary-400"
                               href={uploadUrl}>Upload your pictures</a>}
                    </div>
                </div>

                <div className="flex flex-grow items-center justify-center mb-5 mt-2">
                    {event.reveal_type === 'after' && !event.can_view_photos && <div
                        className="flex text-center flex-row items-center border-2 border-[#2F2F2F] bg-[rgba(41,41,41,0.70)] rounded-[20px] p-[7px] text-white">
                        <h1>Photos will be revealed at <span className="font-bold">{event.reveal_at_formatted}</span>.
                            Please come back then.</h1>
                    </div>}
                    {event.reveal_type === 'hidden' && !event.is_organizer && <div
                        className="flex text-center flex-row items-center border-2 border-[#2F2F2F] bg-[rgba(41,41,41,0.70)] rounded-[20px] p-[7px] text-white">
                        <h1>The organizer of this event chose to hide other people's photos. You can only view your own
                            pictures.</h1>
                    </div>}
                </div>
                {event.can_view_photos &&
                    <Album slideshowAccess={event.live_slideshow_enabled} reloadUrl={reloadUrl} event={event} aspectRatio={aspectRatio} photos={photos} />}
            </div>
        </Layout>
    )
}
